export default __webpack_public_path__ + "static/media/4.d5bf253a.jpg";